import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const CrossRoad5FBlack5EBlack5DRed = () => <CrossRoad coords="1478.000000, 812.000000" color={tracksColors.black}/>;
export default CrossRoad5FBlack5EBlack5DRed;
